import { useGetAllRelays } from '../../../../../shared/delivery/hooks/delivery.hooks';
import React, { useEffect, useMemo, useState } from 'react';
import {
  getDeliveryCitySchedule,
  getDeliveryDayFromDeliveryDate,
} from '../../../../../shared/delivery/utils/delivery.utils';
import moment from 'moment/moment';
import Skeleton from '@material-ui/lab/Skeleton';
import DeliveryRelaysFormControl from '../../../../../components/Admin/Delivery/DeliveryRelaysFormControl';
import DeliveryDateFormControl from '../../../../../components/Admin/Delivery/DeliveryDateFormControl';
import { relayToDeliveryAddress } from '../../../../../shared/delivery/utils/relay/relayDelivery.utils';

export default function RelayDeliveryController({
  isCreateOrder,
  lastOrder,
  selectedDeliveryAddress,
  selectedDeliveryDay,
  setSelectedDeliveryAddress,
  setSelectedBillingAddress,
  setSelectedDeliveryDay,
}) {
  const { loading, relays } = useGetAllRelays();

  const [deliveryDays, setDeliveryDays] = useState(null);
  const [defaultRelay, setDefaultRelay] = useState(null);

  const formattedRelays = useMemo(
    () =>
      relays
        ? relays.map((relay) => {
            const firstLetter = relay.name[0].toUpperCase();
            return {
              firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
              ...relay,
            };
          })
        : [],
    [relays]
  );

  const handleChangeDeliveryRelay = (relay) => {
    if (!relay) {
      setSelectedDeliveryAddress(null);
      setSelectedBillingAddress(null);
      setDefaultRelay(null);
      return setSelectedDeliveryDay(null);
    }

    const availableDeliveryDays = getDeliveryCitySchedule({
      schedules: relay.schedules,
      interval: { from: moment(), to: moment().add(14, 'days') },
    });

    const deliveryAddress = relayToDeliveryAddress(relay, relay.schedule);
    setSelectedDeliveryAddress(deliveryAddress);
    setDefaultRelay({
      firstLetter: relay.name[0].toUpperCase(),
      ...relay,
    });

    if (availableDeliveryDays.length) {
      setDeliveryDays(availableDeliveryDays);
      return setSelectedDeliveryDay(availableDeliveryDays[0]);
    }
  };

  const handleChangeDeliveryDay = (deliveryDay) => {
    setSelectedDeliveryDay(deliveryDay);
  };

  useEffect(() => {
    if (lastOrder && relays?.length) {
      const matchingRelay = relays.find((relay) => relay.id === lastOrder.deliveryInfos?.deliveryId);
      if (!matchingRelay) return;

      const deliveryAddress = relayToDeliveryAddress(matchingRelay, matchingRelay.schedule);
      setSelectedDeliveryAddress(deliveryAddress);
      setDefaultRelay({
        firstLetter: matchingRelay.name[0].toUpperCase(),
        ...matchingRelay,
      });

      const availableDeliveryDays = getDeliveryCitySchedule({
        schedules: matchingRelay.schedules,
        interval: { from: moment(), to: moment().add(14, 'days') },
      });

      setDeliveryDays(availableDeliveryDays);

      if (!isCreateOrder) {
        const deliveryDay = getDeliveryDayFromDeliveryDate({
          deliveryDate: lastOrder.deliveryInfos.deliveryDate,
          deliverySchedule: lastOrder.deliveryInfos.deliverySchedule,
        });

        return setSelectedDeliveryDay(deliveryDay);
      } else {
        return setSelectedDeliveryDay(availableDeliveryDays[0]);
      }
    }
  }, [lastOrder, relays, isCreateOrder]);

  return (
    <>
      {loading && <Skeleton />}
      {!loading && (
        <>
          <DeliveryRelaysFormControl
            defaultRelay={defaultRelay}
            relays={formattedRelays}
            onChange={handleChangeDeliveryRelay}
          />
          {deliveryDays && selectedDeliveryAddress && (
            <DeliveryDateFormControl
              deliveryDays={deliveryDays}
              selectedDeliveryDay={selectedDeliveryDay}
              setSelectedDeliveryDay={handleChangeDeliveryDay}
            />
          )}
        </>
      )}
    </>
  );
}
